export enum IntentType {
  QNA = "qna",
  SUGGESTION_CHIPS = "suggestion_chips",
  INPUT_COLLECTION = "input_collection",
  CALENDLY_SCHEDULE = "calendly_schedule",
  USER_FEEDBACK = "user_feedback",
}